import type { ICharacteristics, ICharacteristic } from '../models/characteristic';

/**
 * Маппер характеристик из GraphQL в формат для компонента characteristics
 */
export function mapCharacteristics(characteristics: any[]): ICharacteristics {
  if (!characteristics || !Array.isArray(characteristics)) {
    return {
      list: [],
      isShortCharacteristics: true,
    };
  }

  const mappedCharacteristics: ICharacteristic[] = characteristics.map((char) => ({
    subtitle: char.title,
    values:
      char.values?.map((value: any) => ({
        name: value.title || '',
        value: value.value || '',
      })) || [],
  }));

  return {
    list: mappedCharacteristics,
    isShortCharacteristics: true,
  };
}
